module.exports = __webpack_public_path__ + "img/logo-twitter.e281af0b.svg";